<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box m-h-700">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">停賣列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body form-inline">
            <div class="form-group text-left">
              <router-link :to="{path: '/crActivity'}">
                <div class="btn btn-default btn-table-title">新增優惠券活動</div>
              </router-link>
            </div>
            <br>
            <!--
            <div class="form-group" v-if="getRoleType === 99">
              <select class="form-control h-38" v-model="ownerTypeSelect" @change="getAttendCoupon">
                <option v-for="owner in ownerType" :value="owner.value">
                  {{owner.label}}
                </option>
              </select>
            </div>
            -->
            <div class="form-group" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo' && ownerTypeSelect !== 1 && getRoleType !== 10" @change="getAttendCoupon">
              <select class="form-control h-38" v-model="brandSelect">
                <option v-for="brand in brandBrief" :value="brand.value">
                  {{brand.label}}
                </option>
              </select>
            </div>
            <div class="form-group" v-if="brandSelect !== 999999 && brandSelect !== '999999' && storeBrief.length > 1 && ownerTypeSelect !== 1 && getRoleType !== 30" @change="getAttendCoupon">
              <select class="form-control h-38" v-model="storeSelect">
                <option v-for="store in storeBrief" :value="store.value">
                  {{store.label}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <select class="form-control h-38" v-model="ruleCodeSelect" @change="getAttendCoupon">
                <option :value="999999">== 活動規則 ==</option>
                <option value="SA00001">消費金額滿額贈 (SA00001)</option>
                <option value="SA00002">消費商品數量滿額贈 (SA00002)</option>
                <option value="SA00003">消費指定商品滿額贈 (SA00003)</option>
              </select>
            </div>
            <div class="form-group">
              <select class="form-control h-38" v-model="timeMethodSelect" @change="getAttendCoupon">
                <option :value="999999">== 時間狀態 ==</option>
                <option value="notyet">未開始</option>
                <option value="going">進行中</option>
                <option value="end">已結束</option>
              </select>
            </div>
            <!--
            <div class="form-group">
              <select class="form-control h-38" v-model="sTimeMethodSelect" @change="getAttendCoupon">
                <option :value="999999">== 策略狀態 ==</option>
                <option value="notyet">未開始</option>
                <option value="going">進行中</option>
                <option value="end">已結束</option>
              </select>
            </div>
            -->
            <div class="form-group">
              <select class="form-control h-38" v-model="statusSelect" @change="getAttendCoupon">
                <option :value="999999">== 活動狀態 ==</option>
                <option value="0">初始狀態</option>
                <option value="1">編輯中</option>
                <option value="3">待上架</option>
                <option value="4">已上架</option>
                <option value="5">已下架</option>
              </select>
            </div>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" @click="checkSort('activity_id')">優惠券活動 (ID)
                      <span v-if="sortMethod === 'activity_id'">
                        <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                        <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                      </span>
                      <span v-else>
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </span>
                    </th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">規則代碼</th>
                    <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">描述</th>-->
                    <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">排序</th>-->
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">時間狀態</th>
                    <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">策略狀態</th>-->
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">活動狀態</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">擁有者</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" @click="checkSort('start_time')">活動開始
                      <span v-if="sortMethod === 'start_time'">
                        <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                        <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                      </span>
                      <span v-else>
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </span>
                    </th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" @click="checkSort('end_time')">活動結束
                      <span v-if="sortMethod === 'end_time'">
                        <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                        <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                      </span>
                      <span v-else>
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </span>
                    </th>
                    <th></th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(coupon, index) in couponList">
                    <td class="sorting_1">{{index + 1}}</td>
                    <td>
                      <router-link :to="'/activityInfo/' + coupon.activity_id">
                        {{coupon.name}} ({{coupon.activity_id}})
                      </router-link>
                    </td>
                    <td>{{coupon.rule_code}}</td>
                    <!--<td>{{coupon.description}}</td>-->
                    <!--<td>{{coupon.sort}}</td>-->
                    <td>
                      <label class="label label-default" v-if="coupon.time_method === 'notyet'">未開始</label>
                      <label class="label label-success" v-else-if="coupon.time_method === 'going'">進行中</label>
                      <label class="label label-danger" v-else-if="coupon.time_method === 'end'">已結束</label>
                    </td>
                    <!--
                    <td>
                      <label class="label label-default" v-if="coupon.strategy_time_method === 'notyet'">未開始</label>
                      <label class="label label-success" v-else-if="coupon.strategy_time_method === 'going'">進行中</label>
                      <label class="label label-danger" v-else-if="coupon.strategy_time_method === 'end'">已結束</label>
                    </td>
                    -->
                    <td>
                      <label class="label label-default" v-if="coupon.status === 0">初始狀態</label>
                      <label class="label label-primary" v-else-if="coupon.status === 1">編輯中</label>
                      <label class="label label-primary" v-else-if="coupon.status === 3">待上架</label>
                      <label class="label label-success" v-else-if="coupon.status === 4">已上架</label>
                      <label class="label label-danger" v-else>已下架</label>
                    </td>
                    <td>
                      <span v-if="coupon.owner_type === 1">平台</span>
                      <span v-if="coupon.owner_type === 2">{{coupon.owner_brand_name}} ({{coupon.owner_id}})</span>
                      <span v-if="coupon.owner_type === 3">{{coupon.owner_brand_name}} - {{coupon.owner_store_name}} ({{coupon.owner_id}})</span>
                    </td>
                    <td>{{coupon.start_time}}</td>
                    <td>{{coupon.end_time}}</td>
                    <td>
                      <button class="btn btn-success" v-if="(coupon.status === 0 || coupon.status === 1 || coupon.status === 3) && coupon.strategy_time_method === 'notyet'" @click="orderCouponPush(coupon)">上架</button>
                      <button class="btn btn-danger" v-if="coupon.status === 4" @click="curCoupon = coupon" data-target="#stopModal" data-toggle="modal">下架</button>
                    </td>
                    <td>
                      <router-link :to="'/upActivity/' + coupon.activity_id" v-if="coupon.status === 0 || coupon.status === 1">
                        <button class="btn btn-primary"><i class="fa fa-pencil"></i></button>
                      </router-link>
                      <button class="btn btn-danger" v-else-if="(coupon.status === 3 || coupon.status === 4) && coupon.time_method === 'notyet'" @click="orderCouponEdit(coupon)"><i class="fa fa-pencil"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                        :groupAmount="groupAmount" :clickPage="clickPage" ref="orderPaginate"
              >
              </paginate>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="storesModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">"{{current.name}}"使用門市</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 p-x-0">
                <label class="label label-primary" style="margin-right: 5px" v-for="store in current.store_list">{{store.name}}</label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal">確定</button>
          </div>
        </div>
      </div>
    </div>
    <m-modal class="text-left" :option="stopOption" @trigger="trigger"></m-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Tables',
  data () {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: 999999,
      storeSelect: 999999,
      ruleCodeSelect: 999999,
      timeMethodSelect: 999999,
      statusSelect: 999999,
      sTimeMethodSelect: 999999,
      ownerTypeSelect: 999999,
      ownerType: [
        {label: '== 擁有者 ==', value: 999999},
        {label: '品牌', value: 2},
        {label: '門市', value: 3},
        {label: '平台', value: 1}
      ],
      couponList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      preSortMethod: [],
      sortToggle: false,
      sortMethod: '',
      curCoupon: {},
      stopOption: {
        id: 'stopModal',
        title: '活動下架',
        body: '確定下架活動?<br>',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'stopActivity'
          }
        ]
      }
    }
  },
  mounted () {
  },
  methods: {
    trigger (event) {
      if (event === 'stopActivity') this.orderCouponStop()
    },
    orderCouponEdit (coupon) {
      var self = this
      var url = '/activity/' + coupon.activity_id + '/orderCouponEdit'
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$router.push('/upActivity/' + coupon.activity_id)
        }
      })
    },
    orderCouponStop () {
      var self = this
      var url = '/activity/' + this.curCoupon.activity_id + '/orderCouponStop'
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getAttendCoupon()
        }
      })
    },
    orderCouponPush (coupon) {
      console.log(coupon.activity_id)
      var self = this
      var url = '/activity/' + coupon.activity_id + '/orderCouponPush'
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getAttendCoupon()
        }
      })
    },
    checkSort (method) {
      this.sortMethod = method
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle
        else {
          this.tableIndex = 1
          this.sortToggle = false
        }
        this.preSortMethod.splice(0, 1)
      } else this.sortToggle = false
      this.preSortMethod.push(method)
      this.getAttendCoupon()
    },
    getBrandBrief () {
      var self = this
      this.brandBrief = [{label: '== 品牌 ==', value: 999999}]
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            if (i === 0 && self.getRoleType === 10) self.brandSelect = obj.value
          }
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = [{label: '== 門市 ==', value: 999999}]
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            /*
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj.value
            } else if (i === 0) self.storeSelect = 999999
            */
            self.storeSelect = 999999
          }
          if (!sList.length) {
            self.couponList = []
            self.total = 0
          }
        }
      })
    },
    getAttendCoupon () {
      var self = this
      var url = '/activity/orderCouponList?page=' + this.tableIndex + '&size=' + this.count
      if (this.storeSelect !== 999999 && this.getRoleType !== 30) {
        url = url + '&owner_id=' + this.storeSelect
        url = url + '&owner_type=' + 3
      } else if (this.brandSelect !== 999999 && this.getRoleType !== 10) {
        url = url + '&owner_id=' + this.brandSelect
        url = url + '&owner_type=' + 2
      }
      if (this.ruleCodeSelect !== 999999) url = url + '&rule_code=' + this.ruleCodeSelect
      if (this.timeMethodSelect !== 999999) url = url + '&time_method=' + this.timeMethodSelect
      if (this.statusSelect !== 999999) url = url + '&status=' + this.statusSelect
      if (this.sTimeMethodSelect !== 999999) url = url + '&strategy_time_method=' + this.sTimeMethodSelect
      if (this.sortMethod) {
        url = url + '&list_sort=' + this.sortMethod + ' '
        if (this.sortToggle) url = url + 'ASC'
        else url = url + 'DESC'
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.couponList = response.data.list
          self.total = response.data.list_total
        }
      })
    },
    clickCurrent (menu) {
      this.current = menu
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    clickPage (index) {
      this.tableIndex = index
      if (index === 1) this.pageGroup = 1
      this.getAttendCoupon()
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    if (this.getRoleType === 10) {
      this.ownerTypeSelect = 3
    }
    this.roleType = parseInt(this.getRoleType, 10)
    this.fixedH()
    this.getBrandBrief()
    this.getAttendCoupon()
  },
  watch: {
    brandSelect () {
      this.ownerTypeSelect = 2
      if (this.brandSelect !== 999999 && this.brandSelect) this.getStoreBrief(this.brandSelect)
    },
    storeSelect () {
      this.ownerTypeSelect = 3
      this.getAttendCoupon()
    }
  }
}
</script>

<style scpoed>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}
.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}
.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
</style>



// WEBPACK FOOTER //
// UpCouponTable.vue?4793e044